module.exports = __webpack_public_path__ + "img/global.93178d5.svg";